import styled, { css } from "styled-components";

import {
  CaretDownFill,
  Image,
  TextCenter,
  TextLeft,
  TextRight,
  XLg,
} from "react-bootstrap-icons";

const alignmentItemsStyle = css<{ $active: boolean }>`
  background-color: ${({ theme, $active }) =>
    $active && theme.primaryBackgroundActive};
  border-radius: 2px;
  cursor: pointer;
`;

export const PageWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  padding-bottom: 8px;
  width: 1224px;
  flex-direction: column;
  gap: 8px;
`;

export const AlignmentOptionsWrapper = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: absolute;
  padding: 2px;
  left: 50%;
  top: 18px;
  width: 60px;
  height: 20px;
  background-color: ${({ theme }) => theme.neutralBackgroundBase};
  border: 1px solid ${({ theme }) => theme.neutralBorder};
  border-radius: 4px;
`;

export const AlignLeftIcon = styled(TextLeft)<{ $active: boolean }>`
  ${alignmentItemsStyle}
`;
export const AlignCenterIcon = styled(TextCenter)<{ $active: boolean }>`
  ${alignmentItemsStyle}
`;
export const AlignRightIcon = styled(TextRight)<{ $active: boolean }>`
  ${alignmentItemsStyle}
`;

export const SectionMenuArrowButton = styled(CaretDownFill)<{
  $active: boolean;
  $isSection?: boolean;
}>`
  display: ${({ $active }) => ($active ? "block" : "none")};
  position: absolute;
  top: 16px;
  right: ${({ $isSection }) => ($isSection ? "16px" : " 16px")};
  cursor: pointer;
  padding: 2px 4px;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  transition: all 0.15s linear;
  background: ${({ theme }) => theme.neutralBackgroundBase};
  color: ${({ theme }) => theme.neutralTextWeak};
  border: 1px solid ${({ theme }) => theme.neutralBorder};
  &:hover {
    color: ${({ theme }) => theme.neutralText};
    border: 1px solid ${({ theme }) => theme.neutralBorderMedium};
  }
  &:active {
    color: ${({ theme }) => theme.neutralText};
    background: ${({ theme }) => theme.neutralBackgroundMedium};
    border: 1px solid ${({ theme }) => theme.neutralBorder};
  }
`;

export const SectionMenuClose = styled(XLg)`
  display: block;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  padding: 2px 4px;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  transition: 0.3s;
  z-index: 1;
  background: ${({ theme }) => theme.neutralBackgroundBase};
  color: ${({ theme }) => theme.neutralTextWeak};
  border: 1px solid ${({ theme }) => theme.neutralBorder};
  &:hover {
    color: ${({ theme }) => theme.neutralText};
    border: 1px solid ${({ theme }) => theme.neutralBorderMedium};
  }
  &:active {
    color: ${({ theme }) => theme.neutralText};
    background: ${({ theme }) => theme.neutralBackgroundMedium};
    border: 1px solid ${({ theme }) => theme.neutralBorder};
  }
`;

export const SectionWrapper = styled.div<{
  $applyBackground?: boolean;
  $backgroundColor?: string;
  $gradient?: string;
  $rgbaColor?: string;
  $imageUrl?: string;
  $isEditMode?: boolean;
  $align?: string;
}>`
  width: 100%;
  height: 481px;
  /* border: 1px solid ${({ theme }) => theme.neutralBackgroundMedium}; */
  border-radius: 8px;
  position: relative;
  background-image: ${({ $imageUrl }) =>
    $imageUrl ? `url(${$imageUrl})` : ""};
  background: ${({ theme, $applyBackground, $backgroundColor, $imageUrl }) =>
    $imageUrl
      ? ""
      : $backgroundColor
      ? $backgroundColor
      : $applyBackground && theme.neutralBackgroundMedium};
  background-size: cover;
  display: flex;
  flex-direction: ${({ $align }) =>
    $align === "right" ? "row-reverse" : "row"};
  &:hover {
    /* border: 1px solid
      ${({ theme, $isEditMode }) =>
      $isEditMode ? theme.primaryBorder : "transparent"}; */

    ${AlignmentOptionsWrapper} {
      display: flex;
    }
    ${SectionMenuArrowButton} {
      display: block;
    }
  }
`;

export const ChartHeader = styled.div`
  padding: 24px 0;
`;
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.textarea`
  font-size: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.neutralText};
  margin-left: 32px;
  border: none;
  resize: none;
  max-width: 340px;
  overflow: hidden;
  background-color: transparent;
  text &:hover {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};
  }

  &:focus-visible {
    background-color: ${({ theme }) => theme.primaryBackground};
    outline: none;
    border-radius: 5px;
  }
`;

export const ItemWrapper = styled.div<{ $reverse?: boolean }>`
  height: 392px;
  display: flex;
  padding: 0 32px;
  gap: 32px;
  flex-direction: ${({ $reverse }) => $reverse && "row-reverse"};
`;

export const ChartWrapper = styled.div`
  width: 799px;
  height: 368px;
`;

export const HighlightsText = styled.textarea`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.neutralText};
  height: 110px;
  width: 329px;
  flex: none;
  border: none;
  resize: none;
  max-width: 340px;
  overflow: hidden;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};
  }

  &:focus-visible {
    background-color: ${({ theme }) => theme.primaryBackground};
    outline: none;
    border-radius: 5px;
  }
`;

export const MapWrapper = styled.div<{
  $draggable?: boolean;
}>`
  height: 479px;
  position: relative;
  border: ${({ $draggable, theme }) =>
    `1px ${
      $draggable ? `dashed ${theme.primaryBorder}` : "solid transparent"
    }`};
`;

const commonContentStyles = css<{ $alignment?: string; $isEditMode?: boolean }>`
  color: #fff;
  border: none;
  resize: none;
  overflow: hidden;
  background-color: transparent;
  text-align: ${({ $alignment }) => $alignment};
  border-radius: 8px;
  cursor: ${({ $isEditMode }) => ($isEditMode ? "text" : "default")};
  border: 1px solid transparent;
  &:hover {
    background-color: ${({ theme, $isEditMode }) =>
      $isEditMode ? theme.neutralBackgroundHover : "none"};
  }

  &:focus-visible {
    outline: none;
    border-radius: 5px;
  }
  &:focus {
    outline: none;
    background-color: ${({ theme, $isEditMode }) =>
      $isEditMode ? theme.primaryBackground : "none"};
    border: 1px solid
      ${({ theme, $isEditMode }) =>
        $isEditMode ? theme.primaryBackground : "none"};
    border-radius: 5px;
  }
`;

export const TextAndImageHeadingContent = styled.div<{ $alignment?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 32px;
  text-align: ${({ $alignment }) => $alignment};
`;
export const ImageContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 32px;
  display: flex;
`;
export const ImageContent = styled.div<{
  $imageUrl?: string;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  background-image: ${({ $imageUrl }) =>
    $imageUrl ? `url(${$imageUrl})` : ""};
`;
export const TextAndImageHeading = styled.textarea.attrs(() => ({
  role: "textbox",
  suppressContentEditableWarning: true,
}))<{
  $alignment?: string;
  $isEditMode: boolean;
  $color: string;
  $isSection?: boolean;
}>`
  width: ${({ $isSection }) => ($isSection ? "100%" : "700px")};
  height: 112px;
  margin-top: ${({ $isSection }) => ($isSection ? "24px" : "80px")};
  font-size: 48px;
  font-weight: 600;
  letter-spacing: -0.05em;
  line-height: 56px;
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? "auto" : "none")};
  color: ${({ $color }) => $color} !important;
  ${commonContentStyles}
`;

export const TextAndImageHighlights = styled.textarea.attrs(() => ({
  role: "textbox",
  suppressContentEditableWarning: true,
}))<{
  $alignment?: string;
  $isEditMode: boolean;
  $color: string;
  $isSection?: boolean;
}>`
  width: ${({ $isSection }) => ($isSection ? "100%" : "700px")};
  height: 128px;
  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
  color: #fff;
  letter-spacing: -0.02em;
  margin-top: 24px;
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? "auto" : "none")};
  color: ${({ $color }) => $color} !important;
  ${commonContentStyles}
`;

export const SectionWrapperBlock = styled.div<{
  $draggable?: boolean;
  $isEditMode?: boolean;
}>`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 24px 32px;
  border: ${({ $draggable, theme }) =>
    `1px ${
      $draggable ? `dashed ${theme.primaryBorder}` : "solid transparent"
    }`};
  border-radius: 8px;
  &:hover {
    border: ${({ theme }) => `1px solid  ${theme.primaryBorder}`};
  }
  ${({ $isEditMode }) => !$isEditMode && ` pointer-events: none; `}
`;

export const TextAndImageDescription = styled.textarea.attrs(() => ({
  role: "textbox",
  suppressContentEditableWarning: true,
}))<{
  $alignment?: string;
  $isEditMode: boolean;
  $color: string;
  $isSection?: boolean;
}>`
  width: ${({ $isSection }) => ($isSection ? "100%" : "700px")};
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #fff;
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? "auto" : "none")};
  margin-top: 24px;
  color: ${({ $color }) => $color} !important;
  ${commonContentStyles}
`;
export const SubsectionTextAndImageTitle = styled.textarea.attrs(() => ({
  role: "textbox",
  suppressContentEditableWarning: true,
}))<{
  $alignment?: string;
  $isEditMode: boolean;
  $color: string;
  $isSection?: boolean;
}>`
  width: ${({ $isSection }) => ($isSection ? "100%" : "700px")};
  height: 60px;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
  color: #fff;
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? "auto" : "none")};
  margin-top: 24px;
  color: ${({ $color }) => $color} !important;
  ${commonContentStyles}
`;
export const SubsectionTextAndImageDescription = styled.textarea.attrs(() => ({
  role: "textbox",
  suppressContentEditableWarning: true,
}))<{
  $alignment?: string;
  $isEditMode: boolean;
  $color: string;
  $isSection?: boolean;
}>`
  width: ${({ $isSection }) => ($isSection ? "100%" : "700px")};
  height: 50px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #fff;
  pointer-events: ${({ $isEditMode }) => ($isEditMode ? "auto" : "none")};
  margin-top: 24px;
  color: ${({ $color }) => $color} !important;
  ${commonContentStyles}
`;

export const UploadBlockWrapper = styled.div<{
  $align?: string;
}>`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  display: flex;
  ${({ $align }) =>
    $align === "right" ? "margin-left: 32px;" : "margin-right: 32px;"};
`;

export const UploadBlock = styled.div<{
  $isCenter?: boolean;
  $imageUrl?: string;
}>`
  display: flex;
  background-color: ${({ theme }) => theme.neutralBackground};
  border: 1px #d3dbe3 solid;
  border-radius: 4px;
  height: ${({ $isCenter }) => ($isCenter ? "193px" : "100%")};
  width: 100%;
  background-image: ${({ $imageUrl }) =>
    $imageUrl ? `url(${$imageUrl})` : ""};
  background-size: cover;
  position: relative;
  &:hover {
    ${AlignmentOptionsWrapper} {
      display: flex;
    }
    ${SectionMenuArrowButton} {
      display: block !important;
    }
  }
`;

export const UploadLabelBlock = styled.label<{
  $isCenter?: boolean;
  $isEditMode?: boolean;
}>`
  transition: 0.2s;
  background-color: ${({ theme }) => theme.neutralBackground};
  color: ${({ theme }) => theme.neutralTextWeak};
  width: 100%;
  height: 100%;
  border-radius: 4px;
  display: flex;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  padding: ${({ $isCenter }) => ($isCenter ? "30px" : "60px")};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &:hover {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.neutralBackgroundHover};
  }
  ${({ $isEditMode }) => !$isEditMode && ` pointer-events: none; `}
`;

export const UploadIconBlock = styled.div`
  height: 56px;
  width: 56px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutralBackgroundActive};
  border-radius: 40px;
  margin-bottom: 8px;
`;

export const UploadIcon = styled(Image)`
  color: ${({ theme }) => theme.neutralTextWeak};
  height: 18px;
  width: 20px;
`;

export const UploadTitle = styled.div`
  display: flex;
  color: ${({ theme }) => theme.neutralTextWeak};
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  justify-content: center;
`;

export const UploadDescription = styled.div`
  display: flex;
  color: ${({ theme }) => theme.neutralTextWeak};
  line-height: 16px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 12px;
`;

export const KpiContainer = styled.div`
  position: relative;
`;
